"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.attrParser = attrParser;
const index_js_1 = require("../../../errors/index.js");
const formatValuePath_js_1 = require("../../../schema/actions/utils/formatValuePath.js");
const cloneDeep_js_1 = require("../../../utils/cloneDeep.js");
const isFunction_js_1 = require("../../../utils/validation/isFunction.js");
const any_js_1 = require("./any.js");
const anyOf_js_1 = require("./anyOf.js");
const list_js_1 = require("./list.js");
const map_js_1 = require("./map.js");
const primitive_js_1 = require("./primitive.js");
const record_js_1 = require("./record.js");
const set_js_1 = require("./set.js");
const utils_js_1 = require("./utils.js");
function* attrParser(attribute, inputValue, options = {}) {
    const { mode = 'put', fill = true, transform = true, defined = false, 
    /**
     * @debt type "Maybe there's a way not to have to cast here"
     */
    parseExtension = utils_js_1.defaultParseExtension, valuePath = [] } = options;
    let filledValue = inputValue;
    let nextFill = fill;
    if (nextFill && filledValue === undefined) {
        let defaultedValue = undefined;
        const modeDefault = attribute.defaults[attribute.key ? 'key' : mode];
        defaultedValue = (0, isFunction_js_1.isFunction)(modeDefault) ? modeDefault() : (0, cloneDeep_js_1.cloneDeep)(modeDefault);
        const itemInput = yield defaultedValue;
        let linkedValue = defaultedValue;
        if (linkedValue === undefined && itemInput !== undefined) {
            const modeLink = attribute.links[attribute.key ? 'key' : mode];
            linkedValue = ((0, isFunction_js_1.isFunction)(modeLink) ? modeLink(itemInput) : linkedValue);
        }
        yield linkedValue;
        filledValue = linkedValue;
        nextFill = false;
    }
    const nextOpts = { ...options, fill: nextFill };
    const { isExtension, extensionParser, basicInput } = parseExtension(attribute, filledValue, {
        transform
    });
    if (isExtension) {
        if (nextFill) {
            // parseExtension does not fill values
            // If fill was set to `true` and input was defined, we yield it twice for fill steps
            const defaultedValue = filledValue;
            yield defaultedValue;
            const linkedValue = defaultedValue;
            yield linkedValue;
        }
        return yield* extensionParser();
    }
    if (basicInput === undefined) {
        const path = (0, formatValuePath_js_1.formatValuePath)(valuePath);
        // We don't need to fill
        if ((0, utils_js_1.isRequired)(attribute, mode) || defined) {
            throw new index_js_1.DynamoDBToolboxError('parsing.attributeRequired', {
                message: `Attribute${path !== undefined ? ` '${path}'` : ''} is required.`,
                path
            });
        }
        const parsedValue = basicInput;
        if (transform) {
            yield parsedValue;
        }
        else {
            return parsedValue;
        }
        const transformedValue = parsedValue;
        return transformedValue;
    }
    switch (attribute.type) {
        case 'any':
            return yield* (0, any_js_1.anyAttrParser)(attribute, basicInput, nextOpts);
        case 'null':
        case 'boolean':
        case 'number':
        case 'string':
        case 'binary':
            return yield* (0, primitive_js_1.primitiveAttrParser)(attribute, basicInput, nextOpts);
        case 'set':
            return yield* (0, set_js_1.setAttrParser)(attribute, basicInput, nextOpts);
        case 'list':
            return yield* (0, list_js_1.listAttrParser)(attribute, basicInput, nextOpts);
        case 'map':
            return yield* (0, map_js_1.mapAttrParser)(attribute, basicInput, nextOpts);
        case 'record':
            return yield* (0, record_js_1.recordAttributeParser)(attribute, basicInput, nextOpts);
        case 'anyOf':
            return yield* (0, anyOf_js_1.anyOfAttributeParser)(attribute, basicInput, nextOpts);
    }
}
